<div class="body">
    <app-header class="visible-in-510"></app-header>

    <!-- CONTENT OF Perfil -->
    <app-body-profile class="width-100"></app-body-profile>

    <app-menu></app-menu>
    
    <app-menu-footer></app-menu-footer>
</div>